import { Component, Input } from '@angular/core';

@Component({
    selector: 'grid-widget',
    templateUrl: './grid-widget.component.html',
    standalone: false
})
export class GridWidget {
    @Input() widgetTitle: string;
    constructor() { }
}